import React from 'react';

import {
  Dimensions,
  Platform,
  Linking,
} from 'react-native';

import * as _hm from './_hm';
import * as _ht from './_ht';

export const c = ( // create element
  type: _ht.o,
  pmrz: _ht.dz,
  clds?: _ht.ls | _ht.o
) => {
  return React.createElement(type, {key: -10, ... pmrz}, clds);
};

export const d = (dvcType: 'p' | 's') => {
  if (dvcType == 'p' && Dimensions.get('window').width >= 1024 ) return true;
  if (dvcType == 's' && Dimensions.get('window').width <  1024 ) return true;
  return false;
};

export const o = (osType: 'i' | 'n' |  'a' | 'w') => {
  if (osType == 'w' && Platform.OS === 'web') return true;
  if (osType == 'n' && (Platform.OS === 'ios' || Platform.OS === 'android')) return true;
  if (osType == 'i' && Platform.OS === 'ios') return true;
  if (osType == 'a' && Platform.OS === 'android') return true;
  return false;
}

export const openUrl = (pz: {
  url: _ht.s, 
//  tgt?: 'url' | 'tel' | 'mail',
  tgt?: 'u' | 't' | 'm', // u: url, t: tel, m: mail
}) => new Promise( _o_end1 => {
  if ( o('w') ) {
    if (navigator.userAgent.match(/Android/)) {
      const _url = `https://docs.google.com/gview?embedded=true&url=${pz.url}`;
      window.open(encodeURI(_url), '_blank', 'location=yes,EnableViewPortScale=yes');
    } else {
      window.open(pz.url, '_blank')
    }
    _o_end1(null);
  }
  else {
    const _url =
      (pz.tgt == 't') ?
       ('tel:' + String(_hm.cvtHkk(pz.url)).replace(/-/g, ''))
      : (pz.tgt == 'm') ?
       ('mailto:' + _hm.cvtHkk(pz.url))
      : pz.url;
    Linking.openURL(_url);
    _o_end1(null);
  }
});
